export const CHECKOUT_MAX_WIDTH_CLASS = 'max-w-4xl';

export const CHECKOUT_PRIMARY_ACTION_CLASS =
  '!bg-chocolate-dark hover:!bg-chocolate-deep active:!bg-chocolate-deep !text-white font-semibold';

export const CHECKOUT_SIDEBAR_GRID_CLASS = 'lg:grid lg:grid-cols-[1fr_300px] lg:gap-6 lg:items-start';

export const TOUCH_TARGET_CLASS = 'min-h-[44px] min-w-[44px]';

const LINK_BUTTON_BASE_CLASS =
  'inline-flex items-center justify-center gap-2 rounded-lg px-6 py-3 min-h-[48px] text-lg transition-colors duration-150';

export const PRIMARY_LINK_BUTTON_CLASS = `${LINK_BUTTON_BASE_CLASS} text-white ${CHECKOUT_PRIMARY_ACTION_CLASS}`;

export const OUTLINE_LINK_BUTTON_CLASS = `${LINK_BUTTON_BASE_CLASS} border border-chocolate-dark text-chocolate-dark font-semibold hover:bg-champagne`;
